import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white border border-outline-color round-4 mx-3 mb-2 p-3" }
const _hoisted_2 = { class: "text-size-14 text-weight-500" }
const _hoisted_3 = { class: "text-size-14 mt-1 text-break" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EvaluationGroup = _resolveComponent("EvaluationGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.officeName), 1),
    _createTextVNode(),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.evaluation.thankYouMessage), 1),
    _createTextVNode(),
    _createVNode(_component_EvaluationGroup, {
      evaluation: _ctx.evaluation,
      class: "mt-2"
    }, null, 8, ["evaluation"])
  ]))
}